import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="ct-grain relative mt-24 border-t border-neutral-200 bg-[#F5F5F5] text-slate-600"
    >
      {/* Stepped circuit pattern at top edge */}
      <svg
        aria-hidden="true"
        className="absolute -top-px left-0 h-3 w-full text-neutral-300"
        preserveAspectRatio="none"
        viewBox="0 0 1200 12"
        fill="none"
      >
        <path
          d="M0 11 L60 11 L60 5 L120 5 L120 11 L240 11 L240 1 L320 1 L320 11 L420 11 L420 5 L520 5 L520 11 L640 11 L640 1 L740 1 L740 11 L860 11 L860 5 L960 5 L960 11 L1060 11 L1060 1 L1140 1 L1140 11 L1200 11"
          stroke="currentColor"
          strokeWidth="1"
        />
      </svg>
      <div className="ct-container relative z-10 grid gap-12 py-16 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-600">
            A technology-driven content company. Built in India, with a global mindset.
            Scaling knowledge through systems, data, and care.
          </p>
          <div className="mt-6 flex flex-col gap-2 text-sm">
            <a
              href="mailto:info@contentiumtech.com"
              data-testid="footer-email"
              className="inline-flex items-center gap-2 text-slate-700 hover:text-[#0A0A0A]"
            >
              <Mail className="h-4 w-4" /> info@contentiumtech.com
            </a>
            <a
              href="tel:+919654006470"
              data-testid="footer-phone"
              className="inline-flex items-center gap-2 text-slate-700 hover:text-[#0A0A0A]"
            >
              <Phone className="h-4 w-4" /> +91 96540 06470
            </a>
            <span className="inline-flex items-center gap-2 text-slate-500">
              <MapPin className="h-4 w-4" /> India
            </span>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-[#0A0A0A]">
            Company
          </h4>
          <ul className="mt-5 space-y-3 text-sm">
            <li><a href="/#about" className="hover:text-[#0A0A0A]">About</a></li>
            <li><Link to="/founder" className="hover:text-[#0A0A0A]">Founder</Link></li>
            <li><a href="/#vision" className="hover:text-[#0A0A0A]">Vision</a></li>
            <li><Link to="/contact" className="hover:text-[#0A0A0A]">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-[#0A0A0A]">
            Legal
          </h4>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to="/privacy" className="hover:text-[#0A0A0A]">Privacy</Link></li>
            <li><Link to="/terms" className="hover:text-[#0A0A0A]">Terms</Link></li>
            <li><Link to="/disclaimer" className="hover:text-[#0A0A0A]">Disclaimer</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-[#0A0A0A]">
            Initiative
          </h4>
          <a
            href="https://eduzy.co"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-eduzy-link"
            className="mt-5 inline-flex items-center gap-1.5 rounded-md border border-neutral-300 bg-white px-3 py-2 text-sm font-medium text-[#0A0A0A] hover:border-[#0A0A0A]"
          >
            Visit Eduzy <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </div>

      <div className="border-t border-neutral-200">
        <div className="ct-container flex flex-col items-start justify-between gap-3 py-6 text-xs text-slate-500 md:flex-row md:items-center">
          <p data-testid="footer-copy">
            © {year} Contentium Tech. All rights reserved.
          </p>
          <p>
            Aligned with the Digital Personal Data Protection Act, 2023.
          </p>
        </div>
      </div>
    </footer>
  );
}
